import React from 'react'
import ResourceAccessLink from './ResourceAccessLink'
import SetAuthorSection from './SetAuthorSection'
import SetAllowComments from './SetAllowComments'
import { IResourceSettingsDrawerProps } from './ResourceDrawer'
import {
  DrawerItem,
  DrawerItemHint,
  Link,
  Text,
  Box,
  Flex
} from 'front-end/src/components'
import { linkBuilder } from '../../../../../../shared/linkBuilder'
import { Trans } from '@lingui/macro'
import IconGraph from '../../../../components/common/icon/IconGraph'

export const ResourceGeneralDrawerContent = ({
  topic
}: {
  topic: IResourceSettingsDrawerProps['topic']
}) => {
  return (
    <>
      <ResourceAccessLink topicId={topic.id} />
      <SetAuthorSection author={topic.author} />
      <SetAllowComments />
      {topic.workspace?.id && (
        <DrawerItem>
          <DrawerItemHint mt={0}>
            <Trans>This resource is part of workspace</Trans>
            <Link ml="4px" href={linkBuilder.workspaceUrl(topic.workspace?.id)}>
              {topic.workspace?.name}
            </Link>
            {topic.relatedPathways.length > 0 && (
              <Box mt="12px">
                <Text>
                  <Trans>It appears in pathways</Trans>
                </Text>
                {topic.relatedPathways.map((pathway) => (
                  <li key={`related-pathway-${pathway.id}`}>
                    <Link href={linkBuilder.pathwayDetail(pathway.id)}>
                      {pathway.title}
                    </Link>
                  </li>
                ))}
              </Box>
            )}
            <Flex align="center" mt="12px">
              <IconGraph mr="8px" />
              <Link href={linkBuilder.analyticsResourceDetail(topic.id)}>
                <Trans>View resource analytics</Trans>
              </Link>
            </Flex>
          </DrawerItemHint>
        </DrawerItem>
      )}
    </>
  )
}
